import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib';
import { getLocationTextStyle } from 'owa-location-persona';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { Link } from 'office-ui-fabric-react/lib/Link';

let styles = require('./DetailRow.scss');
let classNames = require('classnames/bind').bind(styles);

export interface DetailRowProps {
    text: string;
    iconName: string;
    iconSize?: string;
    placeholder?: string;
    ariaLabel?: string;
    onClick?: () => void;
    colorScheme?: ColorScheme;
}

/**
 * This is one row in the detail section of the location card.
 */
function DetailRow(props: DetailRowProps) {
    let { text, iconName, iconSize, placeholder, ariaLabel, onClick, colorScheme } = props;
    let iconStyle = {
        root: {
            fontSize: iconSize ? iconSize : '14px',
        },
    };
    let linkStyle = getLocationTextStyle(colorScheme);

    if (isNullOrWhiteSpace(text) && isNullOrWhiteSpace(placeholder)) {
        return null;
    }

    let isClickable = !!onClick;

    return (
        <div className={styles.detailRow}>
            <Icon
                className={styles.detailRowIcon}
                styles={iconStyle}
                iconName={iconName}
                aria-label={ariaLabel}
            />
            {text && isClickable && (
                <Link
                    className={classNames(styles.detailRowText, linkStyle)}
                    onClick={onClick}
                    title={text}>
                    {text}
                </Link>
            )}

            {text && !isClickable && (
                <div className={classNames(styles.detailRowText, styles.detailText)} title={text}>
                    {text}
                </div>
            )}

            {!text && placeholder && (
                <div className={classNames(styles.detailRowText, styles.detailPlaceholderText)}>
                    {placeholder}
                </div>
            )}
        </div>
    );
}
export default DetailRow;
